export const state = () => ({
    template_id: null,
    shared: false,
    mode: 'View Plans'
})

export const mutations = {
    setTemplateId(state, template_id) {
        state.template_id = template_id;
    },
    setShared(state, shared) {
        state.shared = shared;
    },
    setMode(state, mode) {
        state.mode = mode
    }
}

export const actions = {
}

export const getters = {
}
